/**
 * An example of when this would occur is if the user enters a tradeplan with a symbol like aadsfasf, which does not exist
 * {
	"messageType": "alertNotification",
	"notificationId": 1645458710451,
	"notificationDetails": {"errorType":"SYSTEM_ERROR","notificationType":"ERROR"},
	"status": "SYMBOL_DOES_NOT_EXIST",
	"statusDetails": {"nonExistentSymbol":"XUZ"},
	"date": "2022-02-21T10:51:51.370-0500",
	"timestamp": "1645458711370"
}


 * @param {*} statusDetails 
 * @returns an object with fields:
 * 1) nonExistentSymbol: symbol that was entered that does not exist
 */
export function symbolDoesNotExistParser(statusDetails) {
  const parsedObj = {
    nonExistentSymbol: null,
  };
  if (statusDetails) {
    parsedObj.nonExistentSymbol = statusDetails.nonExistentSymbol ?? null;
  }

  return parsedObj;
}
